import { createModel } from "@rematch/core";
import { client } from "../shared/apiClient";
import { IApiResponseError } from "../shared/dto/IErrorDto";
import { ISentSessionMaterial } from "../interfaces/ISentSessionMaterial";

const sentSessionMaterial = createModel({
  state: {
    sentSessionMaterials: [] as ISentSessionMaterial[],
  },
  reducers: {
    setSessionMaterials: (
      state: any,
      sentSessionMaterials: ISentSessionMaterial[]
    ) => ({
      ...state,
      sentSessionMaterials,
    }),
  },
  effects: (dispatch: any) => ({
    async getSentSessionMaterials(epitchId) {
      await client.api.sentSessionMaterial
        .get(epitchId)
        .then((resp: any) => {
          let sentSessionMaterials: ISentSessionMaterial[] = resp.data;
          this.setSessionMaterials(sentSessionMaterials);
        })
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },
  }),
});

export default sentSessionMaterial;

const onErrorRedirect = (resp: any) => {
  if (!resp.response || resp.response.status === 500) {
    window.location.replace(`${client.api.paths.redirect500}`);
  } else if (resp.response.status === 401 || resp.response.status === 403) {
    window.location.replace(`${client.api.paths.redirect403}`);
  }
};
